import http from "./httpService";
import { apiUrl } from "../../config.js";

const apiEndpoint = apiUrl + "/system/";

export function getAppSystem() {
  return http.get(apiEndpoint);
}

export function getAsideAppSystem() {
  return http.get(apiEndpoint + "aside");
}

export function getAppList() {
  return http.get(apiEndpoint + "app-list");
}

export function getSetupMenu() {
  return http.get(apiEndpoint + "setup-menu");
}
